import {Injectable} from '@angular/core';
import {Observable, Observer, of} from 'rxjs';
import {NavigationHelperPrototypeService} from './custom-components/navigation-helper-prototype/navigation-helper-prototype.service';
import {AlertDialogResult} from './dialogs/alert-dialog/alert-dialog-data';
import {DialogBuilderFactoryService} from './dialogs/dialog-builder/dialog-builder-factory.service';
import {DialogType} from './dialogs/dialog-type';

@Injectable({providedIn: 'root'})
export class CanDeactivateGuard {
  public constructor(
    private readonly dialogBuilderFactoryService: DialogBuilderFactoryService,
    private readonly navigationHelper: NavigationHelperPrototypeService
  ) {}

  public canDeactivate(component: any): Observable<boolean> {
    if (component?.canLeavePage?.() === undefined || component.canLeavePage()) {
      this.navigationHelper.resetNavigationHistory();
      return of(true);
    }

    return new Observable((observer: Observer<boolean>) => {
      this.dialogBuilderFactoryService
        .getBuilder()
        .openAlertDialog({
          type: DialogType.LEAVE_AND_CONTINUE
        })
        .subscribe((result: AlertDialogResult) => {
          if (result === AlertDialogResult.CANCEL) {
            this.navigationHelper.resetNavigationHistory();
            observer.next(true);
          } else {
            observer.next(false);
          }
          observer.complete();
        });
    });
  }
}
